import { useParams } from 'react-router'
import { withoutTrailingSlash } from 'ufo'
import { useLocation } from 'src/utils/router/route'
import { ProfilePageTab } from './constants'

/**
 * Derives the current profile tab from the URL pathname.
 *
 * The layout route matches `/:usernameRaw` and child routes are static
 * segments (e.g. `artworks/:subTab?`), so there is no `params.tab`.
 * This hook parses the pathname to extract the tab segment.
 */
export function useProfileTab(): string {
  const location = useLocation()
  const { usernameRaw } = useParams()
  const username = usernameRaw?.slice(1)
  if (!username) return ProfilePageTab.artworks

  const pathname = withoutTrailingSlash(location.pathname)
  const prefix = `/@${username}/`
  if (!pathname.startsWith(prefix)) return ProfilePageTab.artworks

  const rest = pathname.slice(prefix.length)
  if (rest.startsWith('collection/')) return ProfilePageTab.artworks
  const tab = rest.split('/')[0]
  return tab || ProfilePageTab.artworks
}
